import * as Popover from '@radix-ui/react-popover';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface MajorLabelsProps {
  labels: string[];
}

export function MajorLabels({ labels }: MajorLabelsProps) {
  const { t } = useTranslation('label-perf');
  const [isPopoverOpen, setPopoverOpen] = useState(false);

  if (!labels || labels.length === 0) {
    return (
      <div className="max-w-[11em] p-sm">
        <p className="truncate">--</p>
      </div>
    );
  }

  const firstLabel = labels[0];

  if (labels.length === 1) {
    return (
      <div className="max-w-[10em] p-sm">
        <p className="truncate" title={firstLabel}>
          {firstLabel}
        </p>
      </div>
    );
  }

  const remainingLabels = labels.slice(1);
  const remainingCount = remainingLabels.length;

  return (
    <div className="flex max-w-[11em] items-center gap-x-sm p-sm">
      <p className="truncate" title={firstLabel}>
        {firstLabel}
      </p>

      <Popover.Root open={isPopoverOpen} onOpenChange={setPopoverOpen}>
        <Popover.Trigger asChild>
          <button
            type="button"
            className="flex-shrink-0 cursor-pointer whitespace-nowrap text-body-xs font-semibold underline"
            aria-label={`Show ${remainingCount} more labels`}
          >
            {t('body.moreWithCount', { count: remainingCount })}
          </button>
        </Popover.Trigger>

        <Popover.Portal>
          <Popover.Content
            className="z-50 w-[16em] rounded-sm border-px p-md shadow-lg bg-level-03 border-emphasis-subtle"
            side="bottom"
            align="start"
            sideOffset={8}
          >
            <div className="flex flex-col items-start">
              <span className="mb-sm text-body-sm font-bold text-default">
                {t('body.majorLabels')}
              </span>

              {remainingLabels.map((label) => (
                <span
                  key={label}
                  className="mb-xs text-body-xs font-semibold text-default"
                >
                  {label}
                </span>
              ))}
            </div>
            <Popover.Arrow />
          </Popover.Content>
        </Popover.Portal>
      </Popover.Root>
    </div>
  );
}

MajorLabels.displayName = 'MajorLabelsCell';
